const preferences = {
  preferenceSettings: {
    nameAlreadyExist: 'Wiederholter Name!',
    nameIsEmpty: 'Name nicht eingegeben!',
    notificationPreference:
      'Wählen Sie die Sites und die entsprechenden Einstellungen für Benachrichtigungseinstellungen aus',
    option1: 'Ich möchte von Enphase empfohlene Benachrichtigungen für alle Sites erhalten',
    option2: 'Ich möchte meine Benachrichtigungen anpassen',
    pageHeader: 'Einstellungen',
    title: 'Wählen Sie eine Option für Benachrichtigungen',
    saveDialogHeader: 'Änderungen speichern?',
    saveConfirmText: 'Möchten Sie vorgenommene Änderungen speichern?',
    cancelButton: 'Verwerfen',
    saveButton: 'Speichern',
    defaultDeselectWarning: 'Hinweis: Sie können keine Sites aus dem Standardeinstellungssatz entfernen',
    displayPreferences: 'Einstellungen Anzeigen',
    ownSites: 'Eigene Sites',
    otherSites: 'Andere Sites',
    emptySites: 'Keine Sites vorhanden!',
    emptyPreferenceSet: 'Keine Einstellungen!',
    preference: 'Einstellung',
    actions: 'Maßnahmen',
    settingsInfo: 'Diese Einstellungen gelten nur für Ensemble-Sites',
    selectType: 'Einstellungstypen',
    selectSite: 'Site-Auswahl',
    selectSettings: 'Benachrichtigungseinstellungen',
    addText: 'Hinzufügen',
    deleteAlertHeader: 'Löschvorgang Bestätigen',
    deleteAlertDescription: 'Sind Sie sicher, dass Sie diese Einstellung dauerhaft löschen möchten?',
    deleteAlertCancel: 'Abbrechen',
    deleteAlertConfirm: 'Okay',
    siteEditWarning:
      'Standardmäßig sind alle Sites, die im Besitz sind und alle anderen Sites auf „Standardeinstellung - im Besitz“ und „Standardeinstellung - Andere“ gesetzt, jeweils als ihre Benachrichtigungspräferenz.',
    defaultOwnInfo: 'Alle sich im Besitz befindlichen Sites sind auf „Standardeinstellung - im Besitz“ gesetzt',
    defaultOtherInfo: 'Alle anderen Sites sind auf „Standardeinstellung - Andere“ gesetzt',
    defaultInfo: 'Alle Sites sind auf "Standardeinstellungen" eingestellt.',
    createNew: 'Neue Einstellung hinzufügen',
    siteEditWarningMinimal:
      'Standardmäßig sind Websites als Benachrichtigungseinstellung auf "Standardeinstellung" eingestellt',
    selectAll: 'Wählen Sie Alle',
    generalNotification: 'Allgemeine Benachrichtigungen',
    switchToNewPreferencePage: 'AUF NEUE EINSTELLUNGSSEITE UMSTELLEN'
  },
  preferences: {
    pageHeader: 'Einstellungen',
    title: 'Einstellungen / Konfiguration',
    notificationPreference: 'Benachrichtigungseinstellungen',
    activationNotification: 'Ich möchte über Aktivierungen benachrichtigt werden.',
    monthlySummary: 'Ich möchte monatliche Übersichten der Systemleistungen erhalten.',
    newsletters:
      'Ich möchte Newsletter, Promotionen und Umfragen zu Produkten oder Dienstleistungen von Enphase erhalten.',
    newLeadsNotification: 'Ich möchte über Leads und ihre Statusänderungen benachrichtigt werden.',
    alertEmail: 'EINSTELLUNGEN FÜR E-MAIL- BENACHRICHTIGUNGEN',
    deviceEventsEmail:
      'Ich möchte per E-Mail über Vorkommnisse auf Geräteebene benachrichtigt werden (Wirkebene nachstehend auswählen):',
    exceptionsAlertEmail: 'Sie können Ausnahmen für Ihre Benachrichtigungs-E-Mails je nach System festlegen.',
    alertPreferences: 'Benachrichtigungs-Einstellungen nach System anzeigen',
    saveNotificationPreferences: 'BENACHRICHTIGUNGS-EINSTELLUNGEN SPEICHERN',
    displayPreferences: 'Anzeigeeinstellungen',
    displayUnits: 'Anzeigeeinheiten',
    metric: 'Metrisch',
    imperial: 'Britisches Maß',
    saveDisplayPreferences: 'ANZEIGEEINSTELLUNGEN SPEICHERN',
    systemAlert: 'Systembenachrichtigungs-Einstellung: ',
    saveChanges: 'Änderungen speichern',
    label:
      'Ich möchte per E-Mail über Vorkommnisse auf Geräteebene benachrichtigt werden (Wirkebene nachstehend auswählen):',
    alertEmailPreference: 'Einstellungen für E-Mail-Benachrichtigungen',
    systems: 'Systeme'
  }
};

export default preferences;
